/* eslint-disable */

// import external dependencies
import 'jquery';

// Import everything from autoload


//Swiper
import 'swiper/dist/js/swiper.js'

//select2
import 'select2/dist/js/select2.js'

//Fancybox
import '@fancyapps/fancybox/dist/jquery.fancybox.js'

// Import Beauvoir Modules
import './modules/content-toggle.js'; import './modules/fancybox.js'; import './modules/focus-input.js'; import './modules/hamburger-menu.js'; import './modules/hover-parent.js'; import './modules/newsletter.js'; import './modules/scrollmagic.js'; import './modules/select2.js'; import './modules/swiper.js'

// Import everything from blocks
import '../../views/blocks/banniere/assets/script.js'; import '../../views/blocks/bloc-carrousel/assets/script.js'; import '../../views/blocks/bloc-texte-et-lien/assets/script.js'; import '../../views/blocks/bloc-texte/assets/script.js'; import '../../views/blocks/carrousel-texte-image/assets/script.js'; import '../../views/blocks/citation/assets/script.js'; import '../../views/blocks/coordonnees/assets/script.js'; import '../../views/blocks/formulaire/assets/script.js'; import '../../views/blocks/grille-apercus/assets/script.js'; import '../../views/blocks/listing-des-realisations/assets/script.js'; import '../../views/blocks/realisations/assets/script.js'; import '../../views/blocks/texte-cta/assets/script.js'; import '../../views/blocks/texte-image-fixe/assets/script.js'; import '../../views/blocks/texte-image/assets/script.js'; import '../../views/blocks/valeurs/assets/script.js'
import '../../views/blocks/realisations/assets/script.js'


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	// Home page
	home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js